import React from "react";
import { Form, Input, Select, Button, Row, Col, Image } from "antd";
import "./ContactUs.css";

const { TextArea } = Input;
const { Option } = Select;

const ContactUs: React.FC = () => {
  const [form] = Form.useForm();

  const onFinish = (values: any) => {
    console.log("Form values:", values);
    // Handle form submission here
  };

  return (
    <div className="contact-us-page">
      <div className="contact-us-content">
        <div className="contact-us-header">
          <img
            src="/images/contact-icon.svg"
            alt="Contact Us"
            className="contact-us-icon"
          />
          <h1 className="contact-us-title">Contact Us</h1>
        </div>

        <h2 className="send-message-title">Send Message</h2>

        <Row gutter={[20, 24]} className="contact-us-row">
          <Col xs={24} lg={14} className="contact-form-col">
            <div className="contact-form-container">
              <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                className="contact-form"
              >
                <Form.Item
                  label="Subject"
                  name="subject"
                  rules={[
                    { required: true, message: "Please select a subject" },
                  ]}
                >
                  <Select
                    placeholder="Select a report"
                    className="contact-select"
                    suffixIcon={
                      <img
                        src="/images/chevron-down.svg"
                        alt="dropdown"
                        className="select-icon"
                      />
                    }
                  >
                    <Option value="technical">Technical Issue</Option>
                    <Option value="billing">Billing Question</Option>
                    <Option value="feature">Feature Request</Option>
                    <Option value="general">General Inquiry</Option>
                  </Select>
                </Form.Item>

                <Form.Item
                  label="Name"
                  name="name"
                  rules={[
                    { required: true, message: "Please enter your name" },
                  ]}
                >
                  <Input
                    placeholder="Enter your name"
                    className="contact-input"
                  />
                </Form.Item>

                <Form.Item
                  label="Email"
                  name="email"
                  rules={[
                    { required: true, message: "Please enter your email" },
                    { type: "email", message: "Please enter a valid email" },
                  ]}
                >
                  <Input
                    placeholder="Enter your email"
                    className="contact-input"
                  />
                </Form.Item>

                <Form.Item
                  label="Message"
                  name="message"
                  rules={[
                    { required: true, message: "Please enter your message" },
                  ]}
                >
                  <TextArea
                    placeholder="Enter your message"
                    rows={8}
                    className="contact-textarea"
                  />
                </Form.Item>

                <Form.Item className="submit-button-container">
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="submit-button"
                  >
                    Submit
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </Col>

          <Col xs={24} lg={10} className="contact-image-col">
            <Image
              src="/images/contactus.png"
              alt="Contact Us"
              className="contact-us-image"
              preview={false}
            />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ContactUs;
